export default "__VITE_ASSET__BT5D73I9__"